import React from 'react'
import './Heroright.css'

function Heroright() {
  return (
    <div className='hero__right'>
        <div className='hero__vertical'>
               <div className='v3'></div>            
                <span style={{writingMode:'vertical-rl'}}>michaelakoolo@gmail.com</span>
                <div className='v2'></div>          
            </div>
    </div>
  )
}

export default Heroright